module.exports = __webpack_public_path__ + "img/OKKI.io.a1677277.svg";